var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatUploadFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.44 11.0509L11.25 20.2409C10.1242 21.3667 8.59723 21.9992 7.00505 21.9992C5.41286 21.9992 3.88589 21.3667 2.76005 20.2409C1.6342 19.1151 1.00171 17.5881 1.00171 15.9959C1.00171 14.4037 1.6342 12.8767 2.76005 11.7509L11.95 2.5609C12.7006 1.81033 13.7186 1.38867 14.78 1.38867C15.8415 1.38867 16.8595 1.81033 17.61 2.5609C18.3606 3.31146 18.7823 4.32944 18.7823 5.3909C18.7823 6.45235 18.3606 7.47033 17.61 8.2209L8.41005 17.4109C8.03476 17.7862 7.52577 17.997 6.99505 17.997C6.46432 17.997 5.95533 17.7862 5.58005 17.4109C5.20476 17.0356 4.99393 16.5266 4.99393 15.9959C4.99393 15.4652 5.20476 14.9562 5.58005 14.5809L14.07 6.1009",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatUploadFile);
export default __webpack_public_path__ + "static/media/chat-upload-file.985e2a43931c7f5cdf912b9a0c3ec58c.svg";
export { ForwardRef as ReactComponent };